angular.module('mercury.modules.stock.stocktake')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.Stocktakes', {
    url: '/stocktake/active?:templateId&:itemSuperGroupId',
    templateUrl: 'modules/stock/stocktake/active.tpl.html',
    controller: 'StockStocktakeActiveCtrl',
    reloadOnSearch: false
  })
  .state('Stock.StocktakeCreate', {
    url: '/stocktake/create',
    templateUrl: 'modules/stock/stocktake/create.tpl.html',
    controller: 'StockStocktakeCreateCtrl'
  })
  .state('Stock.StocktakeEdit', {
    url: '/stocktake/edit/:id',
    templateUrl: 'modules/stock/stocktake/edit.tpl.html',
    controller: 'StockStocktakeEditCtrl',
    data: {
      menuLinkState: 'Stock.Stocktakes'
    }
  })
  .state('Stock.StocktakeView', {
    url: '/stocktake/view/:id',
    templateUrl: 'modules/stock/stocktake/view.tpl.html',
    controller: 'StockStocktakeViewCtrl',
    data: {
      menuLinkState: 'Stock.Stocktakes'
    }
  })
  .state('Stock.StocktakeView.StockPrice', {
    url: '/price/:itemId/:quantity/:unitName/:unitRatio/:dateFor',
    data: {
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktake/pricebox.tpl.html',
        controller: 'StockStocktakePriceboxCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  })
  .state('Stock.StocktakeEditRecipes', {
    url: '/stocktake/edit/:id/recipes',
    templateUrl: 'modules/stock/stocktake/editrecipes.tpl.html',
    controller: 'StockStocktakeEditrecipesCtrl',
    data: {
      menuLinkState: 'Stock.Stocktakes'
    }
  })
  .state('Stock.StocktakeEditAreas', {
    url: '/stocktake/edit/:id/areas',
    templateUrl: 'modules/stock/stocktake/editareas.tpl.html',
    controller: 'StockStocktakeEditareasCtrl',
    data: {
      menuLinkState: 'Stock.Stocktakes'
    }
  })
  .state('Stock.StocktakeEditAreaLines', {
    url: '/stocktake/edit/:id/area/:areaId',
    templateUrl: 'modules/stock/stocktake/editarealines.tpl.html',
    controller: 'StockStocktakeEditarealinesCtrl',
    data: {
      menuLinkState: 'Stock.Stocktakes'
    }
  })
  .state('Stock.StocktakeCompleted', {
    url: '/stocktake/completed?report',
    templateUrl: 'modules/stock/stocktake/completed.tpl.html',
    controller: 'StockStocktakeCompletedCtrl'
  });
}]);
